<template>
  <d2-container>
    <el-form :inline="true" size="mini" style="display: flex; flex-wrap: wrap; align-items: center;">
      <el-form-item label="学员姓名/手机">
        <el-input v-model="query.memberKeyword" clearable style="width:200px" placeholder="姓名或手机号" />
      </el-form-item>
      <el-form-item label="培训名称">
        <el-input v-model="query.trainName" clearable style="width:200px" placeholder="分级整期培训名称" />
      </el-form-item>
      <el-form-item style="margin-left: auto;">
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button v-if="isAuth('px:archive:evaluation:export')" icon="el-icon-download" @click="doExport" :loading="exporting">导出</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="rows" border v-loading="loading">
      <el-table-column prop="memberName" label="学员" width="110" />
      <el-table-column prop="trainName" label="培训" min-width="180" />
      <el-table-column prop="batchName" label="批次" min-width="160" />
      <el-table-column prop="coachName" label="教练" width="100" />
      <el-table-column prop="preRating" label="课前评级" width="90" />
      <el-table-column prop="postRating" label="课后评级" width="90" />
      <el-table-column label="结果" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.result === 1 ? 'success' : 'warning'" size="mini">
            {{ scope.row.result === 1 ? '通过' : '未通过' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="evaluateTime" label="评价时间" width="170" />
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="detail(scope.row)">详情</el-button>
          <el-button v-if="isAuth('px:archive:evaluation:void')" type="text" class="danger"  style="padding: 0 8px; height: 28px; display: inline-flex; align-items: center;" @click="voidRow(scope.row)">作废</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page="query.page" :page-size="query.limit" :total="total"
      layout="total, prev, pager, next" @current-change="changePage" style="margin-top:12px" />

    <el-dialog title="评价详情" :visible.sync="visible" width="680px" append-to-body>
      <div v-if="current">
        <el-row :gutter="12" style="margin-bottom:16px">
          <el-col :span="8"><span class="label">学员：</span>{{ current.evaluation.memberName }}</el-col>
          <el-col :span="8"><span class="label">评定级别：</span>{{ current.evaluation.assessmentLevel }}</el-col>
          <el-col :span="8"><span class="label">课前评级：</span>{{ current.evaluation.preRating }}</el-col>
          <el-col :span="8"><span class="label">课后评级：</span>{{ current.evaluation.postRating }}</el-col>
          <el-col :span="8">
            <span class="label">评价结果：</span>
            <el-tag :type="current.evaluation.result === 1 ? 'success' : 'warning'" size="mini">
              {{ current.evaluation.result === 1 ? '通过' : '未通过' }}
            </el-tag>
          </el-col>
          <el-col :span="8"><span class="label">评价时间：</span>{{ current.evaluation.evaluateTime }}</el-col>
          <el-col :span="24" style="margin-top:8px"><span class="label">教练处方：</span>{{ current.evaluation.prescription || '-' }}</el-col>
        </el-row>
        <el-table :data="current.metrics" border size="mini">
          <el-table-column prop="metricLabel" label="指标" />
          <el-table-column label="实测值">
            <template slot-scope="scope">{{ scope.row.actualNumber != null ? scope.row.actualNumber : scope.row.actualText }}</template>
          </el-table-column>
          <el-table-column prop="itemRating" label="单项评级" width="100" />
          <el-table-column label="达标" width="70">
            <template slot-scope="scope">
              <el-tag :type="scope.row.itemPassed ? 'success' : 'warning'" size="mini">{{ scope.row.itemPassed ? '是' : '否' }}</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer">
        <el-button @click="visible = false">关闭</el-button>
      </span>
    </el-dialog>
  </d2-container>
</template>

<script>
import { getEvaluationPage, getEvaluationDetail, voidEvaluation, exportEvaluations } from '@/api/pages/train/archive'

export default {
  data () {
    return {
      loading: false, exporting: false,
      rows: [], total: 0,
      visible: false, current: null,
      query: { page: 1, limit: 10, memberKeyword: '', trainName: '' }
    }
  },
  created () { this.load() },
  methods: {
    search () { this.query.page = 1; this.load() },
    load () {
      this.loading = true
      const params = { page: this.query.page, limit: this.query.limit }
      if (this.query.memberKeyword) params.memberKeyword = this.query.memberKeyword
      if (this.query.trainName) params.trainName = this.query.trainName
      getEvaluationPage(params).then(data => {
        this.rows = data.page.records || []
        this.total = data.page.total || 0
      }).finally(() => { this.loading = false })
    },
    changePage (page) { this.query.page = page; this.load() },
    detail (row) {
      getEvaluationDetail(row.id).then(data => { this.current = data.data; this.visible = true })
    },
    voidRow (row) {
      this.$prompt('请输入作废原因', '作废评价', { inputValidator: v => !!v || '请输入作废原因' })
        .then(({ value }) => voidEvaluation(row.id, value))
        .then(() => { this.$message.success('评价已作废'); this.load() })
        .catch(() => {})
    },
    doExport () {
      this.exporting = true
      const params = {}
      if (this.query.memberKeyword) params.memberKeyword = this.query.memberKeyword
      if (this.query.trainName) params.trainName = this.query.trainName
      exportEvaluations(params).then(blob => {
        const url = URL.createObjectURL(new Blob([blob]))
        const a = document.createElement('a')
        a.href = url
        a.download = '评价记录导出.xlsx'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      }).finally(() => { this.exporting = false })
    }
  }
}
</script>
<style scoped>
.label { color: #909399; font-size: 13px; }
.danger { color: #f56c6c; }
</style>
